import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "lib/global-context";
import GTMProvider from "components/common/GTMProvider";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <StrictMode>
    <BrowserRouter>
      <GTMProvider />
      <Provider>
        <App />
      </Provider>
    </BrowserRouter>
  </StrictMode>,
);
